import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Navbar from "../../../components/main/navbar";
import Footer from "../../../components/main/footer";
import { Box, Grid2, IconButton } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { Mail, Visibility, VisibilityOff } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import hostname from "../../../hostname";

const Signup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    mail: "",
    phone: "",
    password1: "",
    password2: ""
  });

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setFormData({
      ...formData,
      phone: `+${value}`,
    });
  };

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);

  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${hostname}/api/v1/user/auth/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.message) {
          toast.success(data.message);
        }
        navigate("mail-validation");
      } else {
        // Gérer les erreurs d'authentification ici
        const data = await response.json(); // Obtenir les détails de l'erreur du backend
        if (data.message) {
          // Si le backend renvoie un message d'erreur, l'afficher sur le frontend
          toast.error(data.message);
        } else {
          // Si le message d'erreur n'est pas disponible, afficher un message générique
          toast.error("Erreur lors de l'inscription");
        }
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête :", error);
    }
  };

  return (
    <div>
      <Navbar />
      <Grid2 container sx={{ minHeight: "100vh" }}>
        <Container
          container="true"
          maxWidth="sm"
          sx={{
            paddingTop: 5,
            paddingLeft: 3,
            paddingRight: 3,
            paddingBottom: 5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 5,
              borderRadius: "15px",
            }}
          >
            <Avatar sx={{ m: 1, backgroundColor: "#146aff" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              S'inscrire
            </Typography>
            <Box
              component="form"
              onSubmit={handleSignup}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 13,
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#146aff",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#146aff",
                  },
                }}
                margin="normal"
                required
                fullWidth
                id="firstname"
                label="Firstname"
                name="firstname"
                value={formData.firstname}
                onChange={handleChange}
                autoComplete="firstname"
                autoFocus
              />
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 13,
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#146aff",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#146aff",
                  },
                }}
                margin="normal"
                required
                fullWidth
                id="lastname"
                label="Lastname"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
                autoComplete="lastname"
                autoFocus
              />
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 13,
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#146aff",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#146aff",
                  },
                }}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="mail"
                value={formData.mail}
                onChange={handleChange}
                autoComplete="email"
                autoFocus
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Mail />
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <Grid2 item size={{ xs: 12, sm: 12 }}>
                <PhoneInput
                  country={"fr"}
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  placeholder="Phone"
                  inputStyle={{ width: "100%", fontSize: 13, height: "52px" }}
                  containerStyle={{ marginTop: "16px" }}
                  inputProps={{
                    name: "phone",
                    required: true,
                    autoFocus: true,
                  }}
                />
              </Grid2>

              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 13,
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#146aff",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#146aff",
                  },
                }}
                margin="normal"
                required
                fullWidth
                name="password1"
                label="Password"
                type={showPassword1 ? "text" : "password"}
                id="password1"
                value={formData.password1}
                onChange={handleChange}
                autoComplete="current-password"
                slotProps={{
                  input: {
                    endAdornment: (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword1}
                        edge="end"
                      >
                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ),
                  },
                }}
              />
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 13,
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#146aff",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#146aff",
                  },
                }}
                margin="normal"
                required
                fullWidth
                name="password2"
                label="Confirm Password"
                type={showPassword2 ? "text" : "password"}
                id="password2"
                value={formData.password2}
                onChange={handleChange}
                autoComplete="current-password"
                slotProps={{
                  input: {
                    endAdornment: (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                        edge="end"
                      >
                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ),
                  },
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#146aff",
                  "&:hover": { backgroundColor: "#004aad" },
                }}
              >
                S'inscrire
              </Button>
              <Grid2 container justifyContent="space-evenly">
                <Grid2 item>
                  <Link href="/login" variant="body2">
                    {"Connexion !"}
                  </Link>
                </Grid2>
              </Grid2>
            </Box>
          </Box>
        </Container>
      </Grid2>
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default Signup;
